/* @flow */

import React from 'react';
// $FlowIgnore
import { connect } from 'react-redux';

import OpenButtonContainer from 'containers/workflow/OpenButtonContainer';
import ButtonTemplate from 'components/UIKit/Button/ButtonTemplate';
import Row from 'components/UIKit/Flex/Row';
import style from 'components/Upload/style';

const Open = ({closeModal, params, projectData, handleOnClick, ...props}) => {
  const { project, program } = params;

  const onClickOpen = () => {
    handleOnClick().then(r => closeModal())
  }

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      padding: '1rem 1rem 0.5rem 1rem',
    }}>
      <span style={{ textAlign: 'center' }}>Re-opening the project will stop the GDC from reviewing this project. Are you sure you want to reopen?</span>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <ButtonTemplate onClick={closeModal} style={{ margin: '1.5rem', padding: '0.7rem' }}>
          Cancel
        </ButtonTemplate>
        <ButtonTemplate onClick={onClickOpen} style={{ margin: '1.5rem', padding: '0.7rem' }}>
          Confirm
        </ButtonTemplate>
      </div>
    </div>
  )
};

export default connect(
  state => ({
    projects: state.projects.items,
    workflow: state.workflow
  })
)(Open);
